var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMitsubishi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2597_2564",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.00012207,
    width: 22,
    height: 22,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2597_2564)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9987 1.83344L14.7566 8.20353L10.9987 14.5736L7.24083 8.24936L10.9987 1.83344ZM10.9987 14.5736H18.3312L21.9974 20.8062H14.665L10.9987 14.5736ZM10.9987 14.5736H3.66624L0 20.8062H7.33248L10.9987 14.5736Z",
    fill: "#E60012"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMitsubishi);
export default __webpack_public_path__ + "static/media/mitsubishi.3762ccfd06e7bc41483d774969e32cc6.svg";
export { ForwardRef as ReactComponent };